







import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { StringFilterParameter } from "../../system/filters";
import StringFilter from "../../system/filters/StringFilter.vue";
import { FormatReferenceFilterParameter } from ".";

@Component({
  components: {
    StringFilter,
  },
})
export default class FormatReferenceTagFilter extends Mixins(ModelEditableMixin) {
  editingSource: FormatReferenceFilterParameter;

  get tag(): StringFilterParameter {
    return this.editingSource.tag;
  }

  set tag(source: StringFilterParameter) {
    this.writeProperty(s => s.tag = source);
  }
}
